module.exports = __webpack_public_path__ + "assets/img/omron.c4ffed95.png";